export enum InputType {
  Radio = 'Radio',
  Text = 'Text',
  Number = 'Number',
  Phone = 'Phone',
  Email = 'Email',
  Button = 'Button',
  CTAButton = 'CTAButton',
  SecondaryCTAButton = 'SecondaryCTAButton',
  SmallButton = 'Small Button',
}
